<template>
    <v-layout align-center>
        <div class="profile__stat border-red">{{ number }}</div>
        <div class="profile__stat-text ml-3 red-text">{{ text }}</div>
    </v-layout>
</template>

<script>

export default {
  props: {
    number: {

    },
    text: {
      type: String,
    },
  },
};
</script>
